import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  CreateIssuePresignedUrlInput,
  CreateIssuePresignedUrlResponse,
  MutationCreateDispatchIssueDocumentPresignedUploadUrlArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';
import { CreateDispatchDocumentPresignedUploadUrl } from '@/features/IssueHistory/api/queries/CreateDispatchIssueDocumentPresignedUrlEndpoint';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import {} from '@/api/queries';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateIssuePresignedUrlInput]?: CreateIssuePresignedUrlInput[key];
};
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateIssuePresignedUrlResponse>;
}

// Dispatch PresignedURL Service
export const { createDispatchIssueDocumentPresignedUrl, useCreateDispatchIssueDocumentPresignedUrl } = ((): {
  createDispatchIssueDocumentPresignedUrl: ServiceMethod;
  useCreateDispatchIssueDocumentPresignedUrl: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(CreateDispatchDocumentPresignedUploadUrl).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: CreateIssuePresignedUrlInput, options?: ConnectionOptions): Promise<CreateIssuePresignedUrlResponse> => {
        const args: MutationCreateDispatchIssueDocumentPresignedUploadUrlArgs = {
          input: payload,
        };
        const opts = { merge: options?.merge ? 'createDispatchIssueDocumentPresignedUploadUrl' : undefined };
        const res = await fn(args, opts);
        return getProperty('createDispatchIssueDocumentPresignedUploadUrl', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createDispatchIssueDocumentPresignedUrl: fetch,
    useCreateDispatchIssueDocumentPresignedUrl: useService,
  };
})();
